import {action, computed, makeAutoObservable, runInAction} from "mobx"
import {rootStore} from "./index";
import {Order, OrderStatus} from "../services/order/models";
import OrdersRestService from "../services/order/rest";
import {saveStoreToLocalStorage} from "./persistence";
import {Table} from "../services/menu/models";


class OrdersStore {

    orders: Order[] = [];
    currentOrder?: Order;
    isLoaded: boolean = false;
    table?: Table;

    constructor() {
        makeAutoObservable(this);
    }

    @action
    setData(obj: { orders: any[] }) {
        this.orders = obj.orders;
    }

    static fromJSON(obj: any) {
        const ordersStore = new OrdersStore();
        ordersStore.setData({
            orders: obj.orders || []
        });
        return ordersStore;
    }

    @action
    addOrder(order: Order) {
        this.orders.push(order)
        saveStoreToLocalStorage()
    }


    async setCurrentOrder(orderId: number) {
        const getOrderResponse = await OrdersRestService.getOrder(orderId);

        runInAction(() => {
            this.currentOrder = getOrderResponse?.order || undefined;
            this.table = getOrderResponse?.table ?? undefined;
        })
    }


    @action
    forceReload() {
        this.isLoaded = false;
    }


    async reloadCurrentOrder() {
        if (!this.currentOrder) return;

        await this.setCurrentOrder(this.currentOrder.id);
    }


    async reloadOrdersHistory(){
        try{
            const { menuId } = rootStore.generalStore;
            const promises = this.orders.map( async (order) => {
                    if(order.menuId === menuId){
                        // reload
                        const getOrderResponse = await OrdersRestService.getOrder(order.id);
                        if(getOrderResponse?.order){
                            return {
                                ...getOrderResponse.order,
                                deliveryDetails: order.deliveryDetails,
                                clientId: order.clientId
                            }
                        }else{
                            return order;
                        }

                    }else{
                        return order;
                    }
                });

            const updatedList = await Promise.all(promises);

            runInAction(() => {
                this.orders = <Order[]>updatedList;
                saveStoreToLocalStorage();
            })
        }catch (err){
            console.log(err);
        }
    }

    @computed
    getOrdersByMenuId(menuId: number){
        return this.orders.filter(order => (order.menuId === menuId && order.status !== OrderStatus.preorder)).sort((a, b) => {
            return (new Date(b.createdAt)).getTime() - (new Date(a.createdAt)).getTime()
        });
    };
}

export default OrdersStore
